/**
 * Shared UI component for UI Toast.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { Component, computed, effect, input, output } from '@angular/core';

import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';
import { UiToastType } from './ui-toast.types';

@Component({
  selector: 'ui-toast',
  standalone: true,
  imports: [UiLabelTranslatePipe],
  templateUrl: './ui-toast.component.html',
  styleUrl: './ui-toast.component.scss'
})
export class UiToastComponent {
  readonly type = input<UiToastType>('info');
  readonly title = input('');
  readonly message = input('');
  readonly visible = input(false);
  readonly durationMs = input(3000);
  readonly dismiss = output<void>();

  constructor() {
    effect((onCleanup) => {
      if (!this.visible()) {
        return;
      }

      const timeout = setTimeout(() => {
        this.dismiss.emit();
      }, this.durationMs());

      onCleanup(() => clearTimeout(timeout));
    });
  }

  readonly iconSymbol = computed(() => {
    if (this.type() === 'success') {
      return 'done';
    }

    if (this.type() === 'warning') {
      return 'warning';
    }

    if (this.type() === 'error') {
      return 'error';
    }

    return 'info';
  });

  readonly ariaRole = computed(() => (this.type() === 'error' ? 'alert' : 'status'));
}
